<template>
  <div :class="$style.base" v-test="'waiting-list-confirmation'">
    <div :class="$style.inner">
      <IconClock colored large />
      <div :class="$style.heading">
        {{ $t('waiting_list.completed_heading') }}
      </div>
      <div :class="$style.description">
        {{ $t('waiting_list.completed_description') }}
      </div>
      <div :class="$style.summary">
        <div
          v-if="daysOfWeek.length"
          v-test="'waiting-list-summary-days-of-week'"
        >
          <div v-for="day in daysOfWeekSelected" :class="$style.dayOfWeek">
            {{ t(`waiting_list.days.${day.toLowerCase()}`) }}
          </div>
        </div>
        <div v-else v-test="'waiting-list-summary-specific-date'">
          <div :class="$style.bold">
            {{ d(new Date(date), 'monthDay') }}
          </div>
          <div>
            {{ d(new Date(date), 'weekdayLong') }}
          </div>
        </div>
        <div :class="$style.bold" v-test="'waiting-list-services'">
          <div v-for="(service, index) in services" :key="index">
            <div v-if="service.name">
              {{ service.name }}
            </div>
          </div>
        </div>
      </div>
      <BookAgain />
    </div>
  </div>
</template>

<script setup lang="ts">
import IconClock from '@/components/IconClock.vue';
import { useBookingStore } from '@/stores/booking';
import type { DaysOfWeek } from '@/types';
import { useI18n } from 'vue-i18n';
import BookAgain from './shared/BookAgain.vue';

const { services, date, daysOfWeek } = useBookingStore();
const days: DaysOfWeek[] = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'];

const daysOfWeekSelected = days.filter((day) => daysOfWeek.includes(day));

const { d, t } = useI18n();

window.parent.postMessage(
  {
    name: 'waitingListCompleted'
  },
  '*'
);
</script>

<style lang="scss" module>
.base {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 $spacing * 2 $spacing * 2;
  text-align: center;
}

.inner {
  width: 100%;
}

.heading {
  font-size: 20px;
  margin-bottom: $spacing;
}

.description {
  font-weight: bold;
  margin-bottom: $spacing;
}

.bold {
  font-weight: bold;
}

.summary {
  display: flex;
  margin: $spacing * 3 0;

  & > * {
    width: 50%;
    text-align: left;
    padding: 0 $spacing * 2;

    &:last-child {
      border-left: 1px solid rgba(0, 0, 0, 0.13);
    }
  }
}

.dayOfWeek {
  display: inline-block;
  font-size: 12px;
  margin-right: 0.5 * $spacing;
  margin-bottom: 0.5 * $spacing;

  &:not(:last-child) {
    padding-right: 0.5 * $spacing;
    border-right: 1px dashed rgba(0, 0, 0, 0.1);
  }
}
</style>
